export default __webpack_public_path__ + "static/media/screen2.6ab6cb4f.svg";